import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { translate } from '../../Services/translation';
import getDistance from 'geolib/es/getDistance';
import {updatePreferedAddress} from '../../Actions/PreferedAddress.action'
import { useSelector,useDispatch } from 'react-redux';
import { distanceFormat } from "../../Services/Formatting.service";
import { googleAnalytics } from '../../Services/googleAnalytics';

const DealerListDetailTags = (props) => {
  const dispatch = useDispatch();
  const selectedInfo = useSelector((state) => state.preferedAddress.selectedAddress);

  const distance = (lat1, lon1, lat2, lon2, unit) => {
    var dist= getDistance(
      { latitude: lat1, longitude: lon1 },
      { latitude: lat2, longitude: lon2}
  );
  return  (dist/1000);
  }
  const getIcon = (assortment, rindex) => {
    if (assortment == "boat_trailers") {
      return <Fragment><i key={'assortment' + rindex} className='icon-trailerboat'></i></Fragment>
    }
    else if (assortment == "open_trailers") {
      return <Fragment><i key={'assortment' + rindex} className='cart__icon'></i></Fragment>
    }
    else if (assortment == "service") {
      return <Fragment><svg key={'assortment' + rindex}> <use href='/ui/images/sprites/brenderup.svg#service'></use></svg></Fragment>
    }
    else if (assortment == "active" && props.isClickAndCollect == "True") {
      return <Fragment><svg><use href="/ui/images/sprites/brenderup.svg#fast-cart"></use></svg></Fragment>
    }
  }

  const addPreferedAddress = (event, address) => {
    if (event.target.checked == true) {
      dispatch(updatePreferedAddress(address));
    }
    else{
      dispatch(updatePreferedAddress(null));
    }
  }
 
  const sendDataLayer = (shopName, click) => {
    googleAnalytics({
      'event': 'dealerLocatorList', 
      'dealer': shopName,
      'click': click
    })
  }

  return (
    <Fragment>
      {props.addresses &&
        props.addresses.map((address, index) => (
          <li className="dealerlist__repeat" key={'_DetailTag_'+index}>
            <div className="row">
              <div className="columns small-12 dealerlist__basic">
                <div className="dealerlist__image">
                  <img src={address.partnericon} alt="dealer" />
                </div>
                <div className="dealerlist__primary">
                  <div>
                  <span className="dealerlist__basic--name">{props.resellername}</span>
                  <span className="dealerlist__basic--km">{distanceFormat.format(distance(props.lat, props.longt, address.latitude, address.longitude, 'K'))} Km</span>
                  </div>
                 
                  <div className="dealerlist__secondary">
                {address.streetName ? (
                        <span>{address.streetName}, </span>
                      ) : ''}
                    {address.zipCode ? (
                        <span>{address.zipCode}, </span>
                      ) : ''}
                      {address.city ? (
                        <span>{address.city} </span>
                      ) : ''}
                    
                      
                </div>
                </div>
                
              
                <div className="dealerlist__icons">

                  {props.productAssortment != null && props.productAssortment.map((assortment, rindex) => (
                    <Fragment> {getIcon(assortment, rindex)} </Fragment>
                  ))
                  }

                </div>

              </div>
              <div className="columns small-12">
                <details className="dealerlist__moreinfo" key={'RESELLERDEALER' + index}>
                  <summary>
                    <span onClick={() => sendDataLayer(props.resellername, "Open-Dropdown")} className="open-text">{translate('dealerlocator.contactinfo')}</span>
                    <span className="close-text">{translate('dealerlocator.closecontactinfo')}</span>
                    <svg>
                      <use href="/ui/images/sprites/brenderup.svg#down-arrow"></use>
                    </svg>
                  </summary>
                  <code>
                    <ul className="dealerlist__contactinfo">
                      {address.telephone ? (
                        <li onClick={() => sendDataLayer(props.resellername, "phone-number")}>
                          <svg>
                            <use href="/ui/images/sprites/brenderup.svg#phone"></use>
                          </svg>
                          <a href={"tel:" + address.telephone}>{address.telephone}</a></li>
                      ) : ''}
                      {address.homePage ? (
                        <li onClick={() => sendDataLayer(props.resellername, "home-page")}>
                          <svg>
                            <use href="/ui/images/sprites/brenderup.svg#desktop"></use>
                          </svg>
                          <a href={address.homePage} target="_blank">{address.homePage}</a></li>
                      ) : ''}
                      {address.email ? (
                        <li onClick={() => sendDataLayer(props.resellername, "email")}>
                          <svg>
                            <use href="/ui/images/sprites/brenderup.svg#email"></use>
                          </svg>
                          <a href={"mailto:" + address.email}>
                            {translate('dealerlocator.sendmessage')}
                          </a>
                          </li>
                      ) : ''}
                      {address.streetName ? (
                        <li onClick={() => sendDataLayer(props.resellername, "map")}>
                          <svg>
                            <use href="/ui/images/sprites/brenderup.svg#street"></use>
                          </svg>
                          <a href={`https://www.google.com/maps/?q=${address.latitude},${address.longitude}`} target="_blank">{translate('dealerlocator.findhere')}</a>

                          </li>
                      ) : ''}
                      {/* {address.zipCode ? (
                        <li>{address.zipCode}</li>
                      ) : ''}
                      {address.city ? (
                        <li>{address.city}</li>
                      ) : ''}
                      {address.country ? (
                        <li>{address.country}</li>
                      ) : ''} */}

                      <li className="custom-checkbox" onClick={() => sendDataLayer(props.resellername, "prefered")}>
                     

                        <input className="prefer-address" type="checkbox"
                          checked={
                            selectedInfo['addressId'] == address['addressId']
                          }
                          onChange={(event) =>
                            addPreferedAddress(event, address, index, props.markerId)
                          }></input>
                           <label
                            className=""
                        >
                            {translate(
                                'map.preferedretailer'
                            )}
                        </label>
                      </li>
                    </ul>
                  </code>
                </details>
              </div>

            </div>

          </li>
        ))}


    </Fragment>
  );
};

export default DealerListDetailTags;
